import { metricCategoryOrder } from '@pulse/metrics';
import useTemplateMetrics from './useTemplateMetrics';

function useMetricCategoryOrder(params) {
  const { templateMetricCategoryOrder } = useTemplateMetrics(params);
  const res = { ...metricCategoryOrder };
  // add template metric category order for app
  // template metric categories always display first
  const appOrder = res.APP ?? [];
  res.APP = [...templateMetricCategoryOrder, ...appOrder];
  return res;
}

export default useMetricCategoryOrder;
